import React from 'react';
import { useGtm } from '@unisporkal/tracking';
import { RawHtml } from '@unisporkal/utilities';
import { useGallery } from 'app/hooks';
import { useSite } from '@unisporkal/sites';
import iStockExclamation from 'app/images/istock/exclamation.svg';
import gettyExclamation from 'app/images/getty/exclamation.svg';
import styles from './CorrectionsLanguagePreview.module.scss';

const CorrectionsLanguageUndo = () => {
  const gallery = useGallery();
  const gtm = useGtm();
  const site = useSite();
  const Exclamation = site.isGetty() ? gettyExclamation : iStockExclamation;

  const trackEvent = () => {
    gtm.prepareEvent('search', {
      ui_element_location: 'language_correction_back',
    });
  };

  return (
    <section
      data-testid="correction-preview-undo"
      className={styles.container}
    >
      <Exclamation />
      <span
        role="none"
        className={styles.backText}
        onClick={trackEvent}
      >
        <RawHtml>{gallery.undoLangCorrectionData.text}</RawHtml>
      </span>
    </section>
  );
};

export default CorrectionsLanguageUndo;
